/**
 * List of events used by personal details edit widget
 *
 */
export const preferenceQuestionnaire = {
  PREFERENCE_QUESTIONNAIRE_START: 'preferenceQuestionnaire.start',
  PREFERENCE_QUESTIONNAIRE_SEND: 'preferenceQuestionnaire.send',
  PREFERENCE_QUESTIONNAIRE_EDIT: 'preferenceQuestionnaire.edit'
}
